import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const BudgetSheet = () => {
  const location = useLocation();
  const navigate = useNavigate();
  // eslint-disable-next-line no-unused-vars
  const { grampanchayatName, arthikVarshLabel } = location.state || {};

  // Data structure based on images
  // Jama (Income) Data
  const [jamaData, setJamaData] = useState([
    { id: '101', name: 'कर व फी', amount: '100', isHeader: true, bg: 'bg-[#267c77]' },
    { id: '514', name: 'सामान्य पाणीपट्टी', amount: '100', isHeader: false },
    { id: '515', name: 'खास पाणीपट्टी', amount: '0', isHeader: false },
    { id: '518', name: 'घरगुती उपयोग व गुरे व्यतिरिक्त इतर कारणासाठी पुरविलेल्या पाण्याबद्दल फी', amount: '0', isHeader: false },
    { id: '110', name: 'किरकोळ जमा रक्कमा', amount: '0', isHeader: true, bg: 'bg-[#267c77]' },
    { id: '536', name: 'किरकोळ जमा रक्कमा', amount: '0', isHeader: false },
    { id: '137', name: 'पाणि पुरवठा (अंशदान)', amount: '0', isHeader: true, bg: 'bg-[#267c77]' },
    { id: '586', name: 'पाणीपुरवठा विद्युत बिलापोटी (50%) जि.प.कडुन', amount: '0', isHeader: false },
    { id: '587', name: 'पाणी शुद्धीकरण', amount: '0', isHeader: false },
    { id: '588', name: 'नळ जोडणी व इतर पा.पु. अनामत', amount: '0', isHeader: false },
    { id: '589', name: 'पाणीपट्टी नोटीस फी', amount: '0', isHeader: false },
    { id: '590', name: 'पाणीपट्टी जप्ती फी', amount: '0', isHeader: false },
    { id: '142', name: 'कपात', amount: '0', isHeader: true, bg: 'bg-[#267c77]' },
    { id: '592', name: 'भविष्य निधीचे अंशदान', amount: '0', isHeader: false },
    { id: '593', name: 'इतर कपात', amount: '0', isHeader: false },
    { id: '143', name: 'इतर देणी', amount: '0', isHeader: true, bg: 'bg-[#267c77]' },
    { id: '595', name: 'इतर देणी पाणीपुरवठा', amount: '0', isHeader: false },
    { id: '112', name: 'कर्ज अनामत व आगाऊ रक्कमा', amount: '0', isHeader: true, bg: 'bg-[#267c77]' },
    { id: '591', name: 'अनामत रकमा', amount: '0', isHeader: false },
    { id: '111', name: 'कर्ज', amount: '0', isHeader: true, bg: 'bg-[#267c77]' },
  ]);

  // Nave (Exepnditure) Data
  const [naveData, setNaveData] = useState([
    { id: '113', name: 'सामान्य कारभार', amount: '0', isHeader: true, bg: 'bg-[#267c77]' },
    { id: '545', name: 'कार्यालयाचा नैमित्तिक खर्च', amount: '0', isHeader: false },
    { id: '114', name: 'पाणिपुरवठा', amount: '1000', isHeader: true, bg: 'bg-[#267c77]' },
    { id: '546', name: 'नविन पाणीपुरवठा', amount: '1000', isHeader: false },
    { id: '547', name: 'तळ्याच्या दुरुस्त्या', amount: '0', isHeader: false },
    { id: '548', name: 'विहिरींच्या दुरुस्त्या', amount: '0', isHeader: false },
    { id: '549', name: 'नदीवरील घाट सुस्थितीत ठेवणे व बांधकाम', amount: '0', isHeader: false },
    { id: '112', name: 'कर्ज अनामत व आगाऊ रक्कमा', amount: '0', isHeader: true, bg: 'bg-[#267c77]' },
    { id: '591', name: 'अनामत रकमा', amount: '0', isHeader: false },
    { id: '142', name: 'कपात', amount: '0', isHeader: true, bg: 'bg-[#267c77]' },
    { id: '592', name: 'भविष्य निधीचे अंशदान', amount: '0', isHeader: false },
    { id: '593', name: 'इतर कपात', amount: '0', isHeader: false },
    { id: '143', name: 'इतर देणी', amount: '0', isHeader: true, bg: 'bg-[#267c77]' },
    { id: '595', name: 'इतर देणी पाणीपुरवठा', amount: '0', isHeader: false },
    { id: '111', name: 'कर्ज', amount: '0', isHeader: true, bg: 'bg-[#267c77]' },
    { id: '541', name: 'आगाऊ दिलेल्या रक्कमा', amount: '0', isHeader: false },
  ]);

  const handleJamaChange = (index, value) => {
    const newData = [...jamaData];
    newData[index].amount = value;
    setJamaData(newData);
  };

  const handleNaveChange = (index, value) => {
    const newData = [...naveData];
    newData[index].amount = value;
    setNaveData(newData);
  };

  return (
    <div className="min-h-screen bg-gray-50 p-4 md:p-8 font-poppins">
      
      {/* Header */}
         <div className="bg-[#267c77] text-white p-3 px-6 rounded-t-lg mb-4 flex justify-between items-center">
             <h2 className="text-xl font-medium">अंदाज पत्रक</h2>
             <button 
                onClick={() => navigate('/panipuravtha/permanent-info', { state: location.state })}
                className="px-4 py-1 bg-white/20 text-white rounded hover:bg-white/30 transition text-sm font-medium"
             >
                मागे जा
             </button>
         </div>

      {/* Main Content Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          
          {/* Jama Table */}
          <div className="bg-white rounded shadow border border-gray-200">
               <div className="bg-[#267c77] text-white p-2 px-4 font-medium">
                   जमा
               </div>
               <div className="overflow-x-auto h-[600px] overflow-y-auto">
                   <table className="w-full text-left border-collapse">
                       <thead className="bg-[#267c77] text-white sticky top-0 z-10">
                           <tr>
                               <th className="p-2 border-r border-[#1e6b66] w-20">खाते क्र.</th>
                               <th className="p-2 border-r border-[#1e6b66]">खाते नाव</th>
                               <th className="p-2 text-center w-32">रक्कम</th>
                           </tr>
                       </thead>
                       <tbody>
                           {jamaData.map((row, index) => (
                               <tr key={`jama-${index}`} className={`border-b border-gray-200 ${row.isHeader ? 'bg-[#267c77] text-white' : 'hover:bg-gray-50'}`}>
                                   <td className={`p-2 border-r font-medium ${row.isHeader ? 'border-[#1e6b66]' : 'border-gray-200'} text-center`}>{row.id}</td>
                                   <td className={`p-2 border-r font-medium ${row.isHeader ? 'border-[#1e6b66]' : 'border-gray-200'}`}>{row.name}</td>
                                   <td className="p-1 px-2">
                                       <div className="bg-white rounded border border-[#267c77]/30">
                                            <input 
                                                type="text" 
                                                value={row.amount}
                                                onChange={(e) => handleJamaChange(index, e.target.value)}
                                                className={`w-full p-1 text-right focus:outline-none rounded ${row.isHeader ? 'bg-gray-200' : 'bg-white text-black'}`}
                                                disabled={row.isHeader} // Assuming headers summarise or are just headers
                                            />
                                       </div>
                                   </td>
                               </tr>
                           ))}
                       </tbody>
                   </table>
               </div>
          </div>

          {/* Nave Table */}
          <div className="bg-white rounded shadow border border-gray-200">
               <div className="bg-[#267c77] text-white p-2 px-4 font-medium">
                   नावे
               </div>
               <div className="overflow-x-auto h-[600px] overflow-y-auto">
                   <table className="w-full text-left border-collapse">
                       <thead className="bg-[#267c77] text-white sticky top-0 z-10">
                           <tr>
                               <th className="p-2 border-r border-blue-600 w-20">खाते क्र.</th>
                               <th className="p-2 border-r border-blue-600">खाते नाव</th>
                               <th className="p-2 text-center w-32">रक्कम</th>
                           </tr>
                       </thead>
                       <tbody>
                           {naveData.map((row, index) => (
                               <tr key={`nave-${index}`} className={`border-b border-gray-200 ${row.isHeader ? 'bg-[#267c77] text-white' : 'hover:bg-gray-50'}`}>
                                   <td className={`p-2 border-r font-medium ${row.isHeader ? 'border-[#1e6b66]' : 'border-gray-200'} text-center`}>{row.id}</td>
                                   <td className={`p-2 border-r font-medium ${row.isHeader ? 'border-[#1e6b66]' : 'border-gray-200'}`}>{row.name}</td>
                                   <td className="p-1 px-2">
                                        <div className="bg-white rounded border border-blue-300">
                                            <input 
                                                type="text" 
                                                value={row.amount}
                                                onChange={(e) => handleNaveChange(index, e.target.value)}
                                                className={`w-full p-1 text-right focus:outline-none rounded ${row.isHeader ? 'bg-gray-200' : 'bg-white text-black'}`}
                                                disabled={row.isHeader}
                                            />
                                       </div>
                                   </td>
                               </tr>
                           ))}
                       </tbody>
                   </table>
               </div>
          </div>

      </div>

      {/* Footer Buttons */}
      <div className="flex justify-center gap-4 py-4 bg-[#267c77] mt-6 rounded-b-lg">
        <button 
            className="px-6 py-2 bg-[#267c77] text-white rounded hover:bg-[#1e6b66] transition font-medium"
        >
            साठविणे
        </button>
        <button 
            onClick={() => navigate('/panipuravtha/permanent-info')}
            className="px-6 py-2 bg-red-600 text-white rounded hover:bg-red-700 transition font-medium"
        >
            रद्द करणे
        </button>
      </div>

    </div>
  );
};

export default BudgetSheet;
